import { useParams } from "react-router-dom"
import { PathParams } from "../routes/routing-path";
import { useEffect } from "react";
import { TrimUiManager } from "../trim-editor/manager/ui/trim.ui.manager";

export const SystemConfig = () => {
  const {
    kijshopCd,
    shopOrderId,
    orderId,
    imageId,
    staffPkId,
  } = useParams<PathParams>();

  useEffect(() => {
    TrimUiManager.ins.on('t->r:get-shop-order-id', (callback) => {
      callback(shopOrderId);
    });
    return () => {
      TrimUiManager.ins.off('t->r:get-shop-order-id');
    }
  }, [shopOrderId]);

  return <></>;
}